import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { money } from "@/lib/api";

export const FALLBACK_IMG = "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export default function PropertyCard({ property }) {
  const sold = property.total_shares - property.available_shares;
  const funded = Math.round((sold / property.total_shares) * 100);
  return (
    <Link to={`/properties/${property.id}`} className="panel lift lift-gold img-zoom group flex flex-col overflow-hidden" data-testid={`property-card-${property.id}`}>
      <div className="relative aspect-[4/3] overflow-hidden">
        <img src={property.image_url || FALLBACK_IMG} alt={property.title} className="h-full w-full object-cover" />
        <span className="absolute left-4 top-4 rounded-full border border-white/10 bg-obsidian/70 px-3 py-1 font-mono text-[11px] uppercase tracking-wider text-amber-500 backdrop-blur-md">
          {property.property_type}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-6">
        <h3 className="font-display text-lg font-semibold tracking-tight text-white">{property.title}</h3>
        <p className="mt-1 flex items-center gap-1.5 text-sm text-slate-400"><MapPin className="h-3.5 w-3.5" />{property.location}</p>
        <div className="mt-6 grid grid-cols-2 gap-4">
          <div>
            <p className="eyebrow">Per share</p>
            <p className="mt-1 font-mono text-lg tracking-tight text-white">{money(property.share_price, 0)}</p>
          </div>
          <div>
            <p className="eyebrow">Rental yield</p>
            <p className="mt-1 font-mono text-lg tracking-tight text-amber-500">{property.rental_yield}%</p>
          </div>
        </div>
        <div className="mt-6">
          <div className="h-1.5 overflow-hidden rounded-full bg-line">
            <div className="h-full rounded-full bg-amber-600" style={{ width: `${funded}%` }} />
          </div>
          <p className="mt-2 font-mono text-xs text-slate-500">{funded}% funded · {property.available_shares} shares left</p>
        </div>
      </div>
    </Link>
  );
}
